import { JSX } from 'preact'
import { forwardRef } from 'preact/compat'
import classnames from 'classnames'
import { WidgetInstance } from '../types'
import { useStopEventsPropagation, useMergeRefs } from '../hooks'
import { useAnimationTracker } from './useAnimationTracker'
import { Layout } from './Layouts'
import { useComponentStyle } from './Style'

interface Props {
  className?: string
  widget: WidgetInstance
}

export const WidgetRoot = forwardRef<HTMLElement, Props>(function WidgetRoot(
  { className, widget },
  forwardedRef,
): JSX.Element {
  const { ref: trackerRef } = useAnimationTracker()
  const { ref: eventStopperRef } = useStopEventsPropagation()
  const rootRef = useMergeRefs(forwardedRef, trackerRef, eventStopperRef)

  const {
    layout,
    activePage,
    pages,
    preview,
    formState: { sent, sending },
    data,
    version,
  } = widget
  const { closeButton, backButton, header, overlay } = data ?? {}

  const page = pages[activePage]
  const hasPreviousPage = activePage > 0 && (!(sent || sending) || PREVIEW)

  const { classes: pageClasses } = useComponentStyle('page', { id: `${activePage + 1}`, ...page })

  const classes = classnames(className, pageClasses, sending === true && 'form-sending', sent && 'form-sent')

  return (
    <Layout
      innerRef={rootRef}
      className={classes}
      layout={layout}
      expanded={preview?.expanded}
      hasPreviousPage={hasPreviousPage}
      page={page}
      closeButton={closeButton}
      backButton={backButton}
      header={header}
      overlay={overlay}
      version={version}
    />
  )
})
